/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type ClientProductDtoType =
  (typeof ClientProductDtoType)[keyof typeof ClientProductDtoType];

export const ClientProductDtoType = {
  ADMISSIONS_VIEW: 'ADMISSIONS_VIEW',
  FINANCIAL_AID_VIEW: 'FINANCIAL_AID_VIEW',
  PROSPECT_VIEW: 'PROSPECT_VIEW',
  RETENTION_VIEW: 'RETENTION_VIEW',
  TWO_OCEAN: 'TWO_OCEAN',
} as const;
